import React, 
{ 
    useEffect,
    useState 
} from 'react'

import toast from 'react-hot-toast';
import dayjs from 'dayjs';

import { 
    Delete,
    Edit,
} from '@mui/icons-material';

import { 
    Form,
    Input,
    Col, 
    Row,
    Table,
    Space,
    Button,
    DatePicker,
} from 'antd';

// import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'

const BillingAnnualRegi = ({annualData, fetchMembersData, isLoading, id}) => {
    // const navigate = useNavigate() 
    const { callPost, loading } = usePostRequest(()=>{
        fetchMembersData();
    });
    const [annualInfo, setAnnualInfo] = useState([])

    const handleDelete = (key) => {
        const newData = [...annualInfo];
        newData.splice(key, 1); 
        setAnnualInfo(() => newData)
    };
      
    const addRow = () => {
        const newData = [...annualInfo];
        newData.push({
            frstann_ors: '',
            frstann_dates: undefined,
            frstann_amounts: '',
            isWritable: true,
        });
        setAnnualInfo(newData);
    };

    const handleTable = (e, index, name, isDate) => {
        if(isDate){
            setAnnualInfo(prevState => {
                const newState = [...prevState];
                newState[index] = { 
                    ...newState[index],
                    [name]: e
                };
                return newState;
            });
        } else {
            const { value } = e.target

            setAnnualInfo(prevState => {
            const newState = [...prevState];
            newState[index] = { 
                ...newState[index],
                [name]: value
            };
            return newState;
            });
        }
    }

    const handleRowClick = (row_id) => {
        const newData = annualInfo?.map((item, index) => ({
          ...item,
          isWritable: row_id === index ? !item.isWritable : item.isWritable,
        }));
        setAnnualInfo(newData);
    };

    const defaultColumns = [
        {
          title: 'OR',
          dataIndex: 'frstann_ors',
          align: 'center',
          key: 'frstann_ors',
          render: (_, record, index) => (
            record.isWritable ? (
                
                <Input
                    value={record.frstann_ors}
                    onChange={(e) => handleTable(e, index, "frstann_ors")}
                />
            ) : record.frstann_ors
          ),
        },
        {
          title: 'Date',
          dataIndex: 'frstann_dates',
          align: 'center',
          key: 'frstann_dates',
          render: (_, record, index) => (
            record.isWritable ? (
                <DatePicker        
                    style={{width:'100%'}}
                    value={record.frstann_dates}
                    onChange={(e) => handleTable(e, index, "frstann_dates", true)}
                />
            ) : record.frstann_dates?.format('MMMM D, YYYY')
          ),
        },
        {
          title: 'Amount',
          dataIndex: 'frstann_amounts',
          align: 'center',
          key: 'frstann_amounts',
          render: (_, record, index) => (
            record.isWritable ? (
                <Input
                    value={record.frstann_amounts}
                    onChange={(e) => handleTable(e, index, "frstann_amounts")}
                />
            ) : record.frstann_amounts
          ),
        },
        {
            title: '',
            dataIndex: '',
            align: 'center',
            render: (_, record, index) => (
                <Space>
                    {
                        (record.id) && (
                            <div 
                                onClick={() => handleRowClick(index)}
                                className='cursor'
                            >
                                <Edit/>
                            </div>
                        )
                    }
                    <div 
                        onClick={() => handleDelete(index)}
                        className='cursor'
                    >
                        <Delete  
                            style={{
                                color: 'red',
                            }}
                        />
                    </div>
                </Space>
            ),
            onCell: () => ({
                onClick: (e) => {
                e.stopPropagation();
                },
            }),
        },
    ];

    const handleCreateAnnual = () => {
        try { 
            const newValues = {
                member_id: id,
                id: [],
                frstann_ors: [],
                frstann_dates: [],
                frstann_amounts: [],
            }

            annualInfo?.forEach(item => {
                newValues.id.push(item.id || "");
                newValues.frstann_ors.push(item.frstann_ors || "");
                newValues.frstann_amounts.push(item.frstann_amounts || "");
                newValues.frstann_dates?.push(item.frstann_dates ? item.frstann_dates.format("YYYY-MM-DD") : "");
            });

            callPost(
                "members/update_first_annual", 
                newValues,
                false,
            );
        } catch(errorInfo) {
            toast.error('Validation Failed ', errorInfo);
        };
    };

    const validateArray = (array) => {
        return array.every((item) => {
            return item.frstann_ors !== "" || item.frstann_dates !== undefined || item.frstann_amounts !== "";
        });
    };  

    useEffect(() => {
        if(annualData){
            const admission_data = annualData?.map((data) => ({
                id: data.id,
                member_id: data.member_id,
                frstann_ors: data.or,
                frstann_dates: data.date ? dayjs(data.date) : undefined,
                frstann_amounts: data.amount,
                added_by: data.added_by,
                added_on: data.added_on,
                updated_by: data.updated_by,
                updated_on: data.updated_on,
                is_deleted: data.is_deleted,
            }))
             
            setAnnualInfo(admission_data)
        }
    }, [annualData])

    return (
        <Row className='tab-container custom-padding'>
            <Col span={24}>
                <Form 
                    layout="vertical"
                >
                    <Row>
                        <Col span={24} className='responsive-overflow-y'>
                            <Table
                                bordered
                                dataSource={annualInfo}
                                columns={defaultColumns}
                                pagination={false}
                                loading={isLoading}
                                scroll={{ x: 800 }} 
                            />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-4' >
                        <Col span={24}>
                            <Button 
                                type="primary" 
                                onClick={addRow}
                            >
                                Add Row
                            </Button>
                        </Col>
                    </Row>
                    <Row className='btn-footer'>
                        <Space className='p-2'>
                            <Button
                                onClick={handleCreateAnnual}
                                loading={loading}
                                type='primary'
                                disabled={!validateArray(annualInfo)}
                                className='button-color btn-header'
                            >
                                Save
                            </Button>
                        </Space>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}
export default BillingAnnualRegi
